export default __webpack_public_path__ + "static/bb4-97dc7c2f26f589f08abecad3d8f708c0.jpeg";